/**
 * Currency codes as the explorer shows them. Pure - no DOM, nothing of Bootstrap's - so
 * the modules that need it (balance_changes.js, and through it the account export) load
 * in Node's test runner; util.js's currencyToSymbol() is this.
 */

/**
 * A trust line currency code to its symbol: an ISO code ("USD", or its 40-hex form), an
 * AMM LP token ("LP 03AB…"), else the hex code as text.
 * @param {string} currency
 * @param {boolean} skipFakeXRP true: "XRP" as a hex code is "XRP", not "XRP*"
 * @param {Object} lib xrpl.js / xahau.js, for convertHexToString
 */
export function currencyToSymbol(currency, skipFakeXRP, lib = globalThis.window?.xrpl) {
  if(currency.substring(0,8) === '00000000') { //ISO
    return lib.convertHexToString(currency.substring(24,30))
  }

  if(currency.slice(0, 2) == "03") {
    //AMM LP token
    return "LP "+shortenize(currency);
  }

  let r = currency;
  if(r.length !== 3) {
    r = lib.convertHexToString(currency);
    if(currency == '5852500000000000000000000000000000000000' && skipFakeXRP !== true)
      r = 'XRP*'; //non-standard currency code that is similar to "XRP", to prevent confusion * is added to display
    else
      //Every control character, not only \0 - what Util::currencyToSymbol strips on the
      //server. rHzWtXTBrArrGoLDixQAgcSD2dBisM19fF holds codes that start with a 0x02
      //byte (023031516D57...), which printed as an invisible character.
      r = r.replace(/[\x00-\x1F\x7F]/g, '').trim();
  }
  return r;
}

/** util.js's shortenize(), character for character (markup: &hellip;), for the LP token codes above. */
export function shortenize(a, l) {
  if(!a) return '';
  if(!l) l = 4;
  if (a.length <= l * 2) return a;
  return `${a.substring(0, l)}&hellip;${a.slice(-l)}`;
}

export default { currencyToSymbol };
